import Lottie from 'lottie-react';

import emptyMalpracticeCoverage from '../jsons/empty-malpractice-coverage.json';

const EmptyMalpracticeCoverage = props => {
  return <Lottie loop={false} animationData={emptyMalpracticeCoverage} {...props} />;
};

export default EmptyMalpracticeCoverage;
